import React from 'react';

export default ({ size = 16, color = '#000', direction = 'right' }) => (
  <svg
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      style={
        direction === 'left'
          ? { transformOrigin: '50% 50%', transform: 'rotate(180deg)' }
          : null
      }
      fill={color}
      d="M22 12l-4-4v3H3v2h15v3z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Arrow.js